import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import { useHorizontalMenuMode } from '@/modules/core/hooks';
import useAllowNotifications from '@/modules/core/hooks/useAllowNotifications';
import { NotificationButton } from '@/modules/notification';
import { UserDropdown } from '@/modules/user';
import { useSwitchPopupStore } from '@/modules/user/components/UserDrodpdown/stores';
import { UserSwitchPopupInfo } from '@/modules/user/components/UserDrodpdown/UserSwitchPopupInfo';

import { Breadcrumbs } from './Breadcrumbs/Breadcrumbs';

const HEADER_HEIGHT = 72;
const POPUP_OFFSET = '-22px';

interface Props {
  isMobileMode?: boolean;
}

const Topbar: React.FC<Props> = ({ isMobileMode }) => {
  const { isPopupVisible, setIsPopupVisible } = useSwitchPopupStore();
  const isHorizontalMenu = useHorizontalMenuMode();
  const isNotificationsAllowed = useAllowNotifications();

  // const { bannerHeight } = useEmployerTerminationBanner();

  if (isMobileMode) {
    return (
      <div>
        <Box direction="row">
          {isNotificationsAllowed && <NotificationButton isWhiteIcon />}
          <UserDropdown />
        </Box>
      </div>
    );
  }
  return (
    <>
      <Box
        direction="row"
        height={`${HEADER_HEIGHT}px`}
        justify="between"
        align="center"
        margin={{ bottom: 'spacing24' }}
      >
        <Breadcrumbs />
        {!isHorizontalMenu && (
          <Box direction="row" align="center">
            <div id="top-bar-portal"></div>
            {isNotificationsAllowed && <NotificationButton />}
            <UserDropdown />
          </Box>
        )}
      </Box>
      <Box
        width="200%"
        height="1px"
        background={{ color: 'border1' }}
        style={{
          position: 'absolute',
          top: HEADER_HEIGHT,
          left: 0,
        }}
      />
      {isPopupVisible && (
        <>
          <Box
            width="100%"
            justify="end"
            style={{
              position: 'relative',
              top: POPUP_OFFSET,
            }}
          >
            <UserSwitchPopupInfo onSetVisible={setIsPopupVisible} />
          </Box>
          <Box
            background={{ color: 'popup2' }}
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 0,
              left: 0,
              zIndex: 100,
            }}
          />
        </>
      )}
    </>
  );
};
export default Topbar;
